/* eslint-disable react/prop-types, jsx-a11y/href-no-hash, react/sort-comp */
import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'redux';
import 'isomorphic-fetch';

import { themer } from '@spp/theme-provider';

class VideoPaywallOverlay extends Component {
    constructor(props) {
        super(props);

        this.state = {
            additionalAttributes: {},
        };
    }

    componentDidMount() {
        this.assetAttirbutes();
    }

    assetAttirbutes() {
        const { videoAsset } = this.props;
        const url = `https://svp.vg.no/svp/api/v1/vgtv/assets/${videoAsset.id}?appName=svp-player`;

        // eslint-disable-next-line
        fetch(url)
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                return Promise.reject({});
            })
            .then((json) => {
                this.setState({ additionalAttributes: json });
            });
    }

    getBuyUrl() {
        const { videoAsset, articleId } = this.props;

        const params = [
            'utm_source=vgtv-embed',
            `utm_content=${videoAsset.id}`,
            `utm_medium=${articleId}`,
        ];

        return `https://www.vg.no/nyheter/i/jPJ5g9/vg?${params.join('&')}`;
    }

    render() {
        if (this.state.additionalAttributes.id === undefined) {
            return null;
        }
        // by default video asset doesn't have attribute with images
        // thus need to fetch those
        const {
            images: { main },
        } = this.state.additionalAttributes;
        const transformedImage = `${main}?t[]=1280x720`;
        const { spid, isTop, theme } = this.props;

        let loginButton;
        if (spid.login && !spid.userId) {
            loginButton = (
                <a href="#" onClick={spid.login}>
                    logg inn
                </a>
            );
        }

        const className = classnames(theme['video-paywall-overlay'], {
            [theme.top]: isTop,
        });
        return (
            <div className={className}>
                <div
                    className="background-wrapper"
                    style={{ backgroundImage: `url("${transformedImage}")` }}
                >
                    <div>
                        <div className={theme['play-button']}>
                            <div />
                        </div>
                        <div className={theme['info-message']}>
                            For å se filmen må du være VG+ abonnent.{' '}
                            <a href={this.getBuyUrl()}>Kjøp VG+</a>
                            {loginButton ? ' eller ' : undefined}
                            {loginButton}.
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const enhance = compose(
    themer('@vg/ui-video-paywall-overlay'),
    connect(({ article }) => ({
        articleId: article.id,
    })),
);

export default enhance(VideoPaywallOverlay);



/** WEBPACK FOOTER **
 ** ./src/local-components/article/VideoPaywallOverlay.js
 **/